<template>
  <smallModal @escape="$emit('close')">
    <div class="confirm-remove-acc">
      <span>{{ lang['SureAccDel'] + ' ' + service }}?</span>
    </div>
    <hr />
    <div class="buttons">
      <button class="btn btn-secondary" @click="$emit('n')">{{ lang['Сancel'] }}</button>
      <button class="btn btn-success" @click="save">{{ lang['Confirm'] }}</button>
    </div>
    <!-- этот див для автофокуса, чтобы работал Enter -->
    <div ref="confirmRemoveAcc" tabindex="0">
    </div>
  </smallModal>
</template>

<script>
import { keyevent } from '@/main.js'; // Імпорт глобального об'єкта keyevent для обміну подіями між компонентами
import smallModal from '../modals/smallModal'; // Компонент маленького модального вікна

export default {
  props: ['service'],
  components: {
    smallModal
  },
  data() {
    return {
    }
  },
  created() {
  },
  mounted() {
    // автофокус для дива
    this.$nextTick(() => {
      this.$refs.confirmRemoveAcc.focus();
    });
    keyevent.$off('enter');
    keyevent.$on('enter', () =>
      this.save()
    );
  },
  methods: {
    // событие для клавишы (можно удалить после теста)
    // onKeyDown(event) {
    // if (event.key === "Enter") {
    //     this.save()
    // }
    // },
    save() {
      this.$emit("y");
      this.$emit("close");
    }
  },
  computed: {
    // Мова додатку
    lang() {
      return window.lang
    },
  }
}
</script>

<style scoped>
.buttons {
  display: flex;
  justify-content: space-between;
}

.btn-secondary,
.btn-success {
  width: 49%;
}


.btn-success {
  background-color: #00c279;
  border: none;
  text-transform: uppercase;
  font-size: 10pt;
}

.btn-success:not(:disabled):not(.disabled):active {
  background-color: #00B26F;
}

.btn-success.disabled,
.btn-success:disabled {
  background-color: #00B26F;
  border: none;
}

.btn-success:hover {
  background-color: #00B26F;
}

.btn-secondary {
  color: gray;
  background-color: white;
  border: none;
  text-transform: uppercase;
  font-size: 10pt;
}

.btn-secondary:not(:disabled):not(.disabled):active {
  background-color: white;
  color: gray;
}

.btn-secondary:hover {
  text-decoration: underline;
  color: gray;
  background-color: white;
}

.confirm-remove-acc {
  text-align: center;
}
</style>